import { Injectable, isDevMode } from '@angular/core';
import { Logger } from './logger.service';

const noop = (): any => undefined;

@Injectable()
export class ConsoleLoggerService implements Logger {
  public get info() {
    if (this.isDev) {
      return console.info.bind(console);
    } else {
      return noop;
    }
  }

  public get warn() {
    if (this.isDev) {
      return console.warn.bind(console);
    } else {
      return noop;
    }
  }

  public get error() {
    if (this.isDev) {
      return console.error.bind(console);
    } else {
      return noop;
    }
  }

  public get log() {
    if (this.isDev) {
      return console.log.bind(console);
    } else {
      return noop;
    }
  }

  private isDev = isDevMode();

  public invokeConsoleMethod(type: string, args?: any): void {
    const logFn = console[type] || console.log || noop;
    logFn.apply(console, [args]);
  }
}
